// extracted by mini-css-extract-plugin
export default {"checkboxOptions":"checkboxOptions-KQXLQ","menu":"menu-KbZxc","menuWrapper":"menuWrapper-noGtk","menuArrow":"menuArrow-pwknL"};